var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4297 8.13021C35.1594 8.13021 26.5886 0.464178 26.5038 0.387379C25.9341 -0.129096 25.0658 -0.129096 24.4962 0.387379C24.4109 0.464775 15.8626 8.13021 7.57031 8.13021C6.74515 8.13021 6.07617 8.79919 6.07617 9.62435V27.518C6.07617 42.0135 16.8575 47.8058 24.9671 50.9018C25.1387 50.9673 25.3193 51 25.5 51C25.6807 51 25.8613 50.9672 26.0329 50.9018C37.4037 46.5608 44.9238 39.7895 44.9238 27.518V9.62435C44.9238 8.79919 44.2549 8.13021 43.4297 8.13021Z",
    fill: "url(#paint0_linear_349_76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.041C19.7329 15.041 15.041 19.7329 15.041 25.5C15.041 31.2671 19.7329 35.959 25.5 35.959C31.2671 35.959 35.959 31.2671 35.959 25.5C35.959 19.7329 31.2671 15.041 25.5 15.041ZM29.5447 25.0623L25.0623 29.5447C24.7707 29.8365 24.3883 29.9824 24.0059 29.9824C23.6235 29.9824 23.2411 29.8366 22.9494 29.5447L21.4553 28.0506C20.8717 27.4671 20.8717 26.5211 21.4553 25.9376C22.0387 25.3541 22.9848 25.3541 23.5683 25.9376L24.006 26.3752L27.4319 22.9493C28.0153 22.3658 28.9614 22.3658 29.5449 22.9493C30.1283 23.5328 30.1283 24.4788 29.5447 25.0623Z",
    fill: "url(#paint1_linear_349_76)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_76",
    x1: 25.5,
    y1: 51,
    x2: 25.5,
    y2: -0.00000143051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_76",
    x1: 25.5,
    y1: 35.959,
    x2: 25.5,
    y2: 15.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#F0FFF4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.63e6ae94562d2d9566a799e075045f34.svg";
export { ForwardRef as ReactComponent };